"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var components_1 = require("components");
var styles_1 = require("styles");
var styles = {
    container: {
        display: 'flex',
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
    },
    backdrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: styles_1.BackgroundColor.Black,
        opacity: .25,
    },
    noBackdrop: {
        opacity: 0,
    },
    modal: {
        display: 'flex',
        width: 300,
        height: 200,
        borderRadius: 4,
        zIndex: 1,
    },
};
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        var _a = this.props, children = _a.children, noBackdrop = _a.noBackdrop, open = _a.open, style = _a.style, onClose = _a.onClose, otherProps = __rest(_a, ["children", "noBackdrop", "open", "style", "onClose"]);
        return open && (React.createElement("div", { style: styles.container },
            React.createElement(components_1.Paper, __assign({ elevation: 2, style: [styles.modal, style] }, otherProps), children),
            React.createElement("div", { style: [
                    styles.backdrop,
                    noBackdrop && styles.noBackdrop,
                ], onClick: onClose })));
    };
    Modal.defaultProps = {
        noBackdrop: false,
        onClose: function () { return; },
    };
    Modal = __decorate([
        Radium
    ], Modal);
    return Modal;
}(react_1.PureComponent));
exports.Modal = Modal;



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.tsx
// module id = 316
// module chunks = 0